import React from "react";
import { Box, Button, Modal } from "@mui/material";
import styled from "styled-components";

type ModalLargeProps = {
  open: boolean;
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  title?: string;
};

export default function ModalLarge({
  open,
  onClose,
  title,
  children,
}: React.PropsWithChildren<ModalLargeProps>) {
  const buttonCloseClickHandle = React.useCallback(() => {
    if (onClose) {
      onClose({}, "backdropClick");
    }
  }, [onClose]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "2rem",
          left: "2rem",
          width: "calc(100% - 4rem)",
          height: "calc(100% - 4rem)",
          bgcolor: "background.paper",
          boxShadow: 24,
          overflow: "scroll",
          padding: "0.5rem",
        }}
      >
        <h2 id="modal-title">{title}</h2>
        <p id="modal-description">{children}</p>
        <DivButtonUpperRight>
          <Button onClick={buttonCloseClickHandle}>Close</Button>
        </DivButtonUpperRight>
        <Button onClick={buttonCloseClickHandle}>Close</Button>
      </Box>
    </Modal>
  );
}

const DivButtonUpperRight = styled.div`
  & button {
    position: absolute;
    display: block;
    top: 1rem;
    right: 1rem;
  }
`;
